<template>
  <div class="page-information">
    <div class="information-search">
      <span class="search-label">{{ filterLabel }}：</span>
      <el-input
        class="search-input"
        size="small"
        v-model="filterName"
        placeholder="请输入内容"
      ></el-input>
      <el-button
        class="search-but1"
        size="small"
        type="primary"
        @click="handleSearch"
      >
        搜索
      </el-button>
      <el-button class="search-but1" size="small" @click="handleReset">
        重置
      </el-button>
    </div>
    <div class="information-tag">
      <el-tag
        class="tag-item"
        size="medium"
        v-for="item in tagList"
        :key="item.label"
        :effect="type === item.value ? 'dark' : 'light'"
        @click="handleTag(item.value)"
      >
        {{ item.label }}
      </el-tag>
    </div>
    <div class="information-add">
      <el-button size="small" type="primary" @click="handleAdd">新建</el-button>
    </div>
    <div class="information-table">
      <el-table v-if="type === 1" key="1" :data="veteranList" style="width: 100%" :border="true" v-loading="loading" row-key="id">
        <el-table-column
          v-for="item in column1"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width || '100'"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <template v-if="item.prop === 'title'">
              <span v-html="scope.row.title" />
            </template>
            <template v-else>{{ tableTranslation(item.prop, scope.row) }}</template>
          </template>
        </el-table-column>
        <el-table-column key="option" prop="option" label="操作" align="center" min-width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleStatus(scope.row)">{{ scope.row.status === 2 ? '启用' : '禁用' }}</el-button>
            <el-button type="text" @click="handleEditor(scope.row)">编辑</el-button>
            <el-button v-if="scope.row.status === 2" type="text" @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table v-else-if="type === 2" key="2" :data="veteranList" style="width: 100%" :border="true" v-loading="loading" row-key="id">
        <el-table-column
          v-for="item in column2"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          align="center"
          :min-width="item.width || '100'"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <template v-if="item.prop === 'infoName'">
              <a href="javascript:;" @click="openDetail(scope.row)">{{ scope.row.infoName }}</a>
            </template>
            <template v-else-if="item.prop === 'linkUrl'">
              <span v-if="scope.row.status === 1">
                {{ `${domainUrl}/veteranDetail?rePath=/veteranList&reLabel=退役军人培训&id=${scope.row.id}` }}
              </span>
            </template>
            <template v-else-if="item.prop === 'img' && scope.row.img">
              <img
                class="table-img"
                :src="scope.row.img"
                alt="资讯封面"
                @click="lookBigImg(scope.row)"
              />
            </template>
            <template v-else-if="item.prop === 'status'">
              <span v-if="scope.row.status === 1">已发布</span>
              <span v-else-if="scope.row.status === 2">已下架</span>
              <span v-else> -- </span>
            </template>
            <template v-else>
              {{ tableTranslation(item.prop, scope.row) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          key="option"
          prop="option"
          label="操作"
          align="center"
          min-width="180"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.status === 1" @click="handleCancelTop(scope.row)">
              {{ scope.row.topFlag === 2 ? '取消置顶' : '置顶' }}
            </el-button>
            <el-button type="text" @click="handleStatus(scope.row)">
              {{ scope.row.status === 2 ? '上架' : '下架' }}
            </el-button>
            <el-button type="text" @click="handleEditor(scope.row)">编辑</el-button>
            <el-button v-if="scope.row.status === 2" type="text" @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table v-else key="3" :data="veteranList" style="width: 100%" :border="true" v-loading="loading" row-key="id">
        <el-table-column
          v-for="item in column3"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          align="center"
          :min-width="item.width || '100'"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <template v-if="item.prop === 'img' && scope.row.img">
              <img
                class="table-img"
                :src="scope.row.img"
                alt="机构宣传图"
                @click="lookBigImg(scope.row)"
              />
            </template>
            <template v-else-if="item.prop !== 'img'">
              {{ tableTranslation(item.prop, scope.row) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          key="option"
          prop="option"
          label="操作"
          align="center"
          min-width="180"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleStatus(scope.row)">{{ scope.row.status === 2 ? '启用' : '禁用' }}</el-button>
            <el-button type="text" @click="handleEditor(scope.row)">编辑</el-button>
            <el-button v-if="scope.row.status === 2" type="text" @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="information-pagination">
      <el-pagination
        @size-change="handleLimitChange"
        @current-change="handlePageChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
    <component
      v-if="writeDialogFlag"
      :is="componetEl"
      :dialogTitle="writeDialogTitle"
      :handleClose="handleCloseWriteDialog"
      :close="close"
      :defaultData="writeDialogData"
      :typeId="type"
    />
    <PublicShowImg ref="showImgRef" />
    <InformationPreview
      v-if="previewFlag"
      :handleClose="handCloseDetail"
      :viewData="row"
    />
  </div>
</template>
<script>
import * as API from '@/api/veteran/index'
import { column1, column2, column3, tagList } from './assets'
import IntroduceDialog from './introduceDialog.vue'
import WriteDialog from './writeDialog.vue'
import CooperateWrite from './cooperateDialog.vue'
import InformationPreview from './preview.vue'
import PublicShowImg from '../swiperManage/openImg.vue'
export default {
  name: 'VeteranManage',

  components: { IntroduceDialog, WriteDialog, CooperateWrite, PublicShowImg, InformationPreview },
  data() {
    return {
      tagList,
      filterName: '',
      infoName: '',
      type: 1,
      column1,
      column2,
      column3,
      veteranList: [],
      total: 0,
      page: 1,
      limit: 10,
      loading: false,
      writeDialogFlag: false,
      writeDialogTitle: '',
      writeDialogData: {},
      previewFlag: false,
      row: null
    }
  },
  computed: {
    componetEl () {
      switch (this.type) {
        case 1:
          return 'IntroduceDialog'
        case 2:
          return 'WriteDialog'
        case 3:
        case 4:
          return 'CooperateWrite'
        default:
          return ''
      }
    },
    filterLabel () {
      switch (this.type) {
        case 1:
          return '标题'
        case 2:
          return '资讯名称'
        case 3:
        case 4:
          return '机构名称'
        default:
          return ''
      }
    },
    domainUrl () {
      if (process.env.VUE_APP_CURRENTMODE === 'prod') {
        return 'https://www.nrtatalent.cn'
      }
      return 'http://tvpc.shenlakaoyan.com'
    }
  },
  created() {
    this.getVeteranList()
  },
  methods: {
    openDetail(row) {
      this.row = row
      this.previewFlag = true
    },
    handCloseDetail() {
      this.previewFlag = false
    },
    // 获取资讯列表
    async getVeteranList() {
      this.loading = true
      const { page, limit, type } = this
      const params = { page, limit, type }
      switch (this.type) {
        case 1:
          params.title = this.filterName
          break
        case 2:
        case 3:
          params.name = this.filterName
          break
      }
      try {
        const res = await API.getVeteranPageList(params)
        const {
          code,
          data: { records = [], total }
        } = res
        if (code === 0) {
          this.veteranList = records.map((item, ind) => ({
            ...item,
            index: (page - 1) * limit + ind + 1
          }))
          this.total = Number(total)
        }
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    // 切换资讯类型
    handleTag(ind) {
      this.page = 1
      this.type = ind
      this.getVeteranList()
    },
    // 表格单元格转换
    tableTranslation(key, row) {
      switch (key) {
        case 'status':
          switch (row[key]) {
            case 1:
              return '已启用'
            case 2:
              return '已禁用'
            default:
              return ''
          }
        case 'topFlag':
          if (row['status'] === 1) {
            switch (row[key]) {
              case 1:
                return '未置顶'
              case 2:
                return '已置顶'
              default:
                return ''
            }
          } else {
            return '-'
          }
        case 'attachFlag':
          switch (row[key]) {
            case 0:
              return '否'
            case 1:
              return '是'
            default:
              return ''
          }
        default:
          return row[key]
      }
    },
    // 换每页条数
    handleLimitChange(limit) {
      this.limit = limit
      this.page = 1
      this.getVeteranList()
    },
    // 换页
    handlePageChange(page) {
      this.page = page
      this.getVeteranList()
    },
    // 搜索
    handleSearch() {
      this.page = 1
      this.getVeteranList()
    },
    // 重置
    handleReset() {
      this.page = 1
      this.limit = 10
      this.infoName = ''
      this.getVeteranList()
    },
    // 表格操作项点击取消置顶
    async handleCancelTop({ id }) {
      try {
        const { code } = await API.topInformation({ id })
        if (code === 0) {
          this.getVeteranList()
        }
      } catch (error) {}
    },
    // 单元格点击查看封面大图
    lookBigImg(row) {
      const { img, name } = row
      this.$refs.showImgRef.show(img, name)
    },
    // 表格操作项点击编辑
    handleEditor(row) {
      this.writeDialogTitle = '编辑资讯'
      this.writeDialogData = row
      this.writeDialogFlag = true
    },
    // 表格操作项点击删除
    handleDel(row) {
      const { id, title, name } = row
      this.$confirm(`确认要删除${this.type === 1 ? title : name}吗？`, {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async () => {
          const res = await API.veteranDel({ id })
          const { code } = res
          if (code === 0) {
            this.getVeteranList()
          }
        })
        .catch(() => {})
    },
    // 表格操作项点击发布、下架
    handleStatus(row) {
      const { id, name, title, status } = row
      let t = title
      let o = ['禁用', '启用']
      if (this.type === 2) {
        t = name
        o = ['下架', '上架']
      } else if (this.type > 2) {
        t = name
      }
      let st = status === 1 ? 2 : 1
      this.$confirm(`确认要${o[status - 1]}${t}吗？`, {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async () => {
          const { code } = await API.updateStatus({ id, status: st })
          if (code === 0) {
            this.getVeteranList()
          }
        })
        .catch(() => {})
    },
    close(bool) {
      this.writeDialogFlag = false
      switch (bool) {
        case 'reset':
          this.handleReset()
          break
        case 'update':
          this.getVeteranList()
          break
        default:
          break
      }
    },
    // 新建、编辑资讯弹框关闭
    handleCloseWriteDialog(bool, infoTitle) {
      if (infoTitle && infoTitle !== '<p><br></p>') {
        this.$confirm('此操作将关闭弹窗, 并且不保留您的编辑记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.close(bool)
        }).catch(() => {});
      } else {
        this.close(bool)
      }
    },
    // 新建资讯
    handleAdd() {
      this.writeDialogTitle = '新建资讯'
      this.writeDialogData = {}
      this.writeDialogFlag = true
    }
  }
}
</script>
<style lang='scss' scoped>
.page-information {
  background: #fff;
  padding: 20px;
  .information-search {
    margin-bottom: 20px;
    .search-label {
      margin-right: 10px;
    }
    .search-input {
      width: 230px;
      margin-right: 100px;
    }
    .search-but1 {
      margin-right: 10px;
    }
    .search-but2 {
      margin-right: 10px;
    }
  }
  .information-tag {
    margin-bottom: 20px;
    .tag-item {
      cursor: pointer;
    }
  }
  .information-add {
    margin-bottom: 20px;
  }
  .information-table {
    margin-bottom: 20px;
    .table-img {
      width: 100px;
      height: 20px;
      cursor: pointer;
    }
  }
}
</style>
